$(document).ready(function() {

	// Check page contains a map section
	if( $('.section-map').length ) {


		// Clicked map nav child item title
		$('.map-nav .child-item__title').click(function() {
			// console.log('111');

			// Get the parent map section
			const mapSection = $(this).closest('.section-map');

			// Get the value of the data-imp-trigger-object-on-mouseover attribute (eg 'Spot 1')
			const spotTitle = $(this).attr('data-imp-trigger-object-on-mouseover');

			// De-activate all spots
			$('.imp-object-spot').removeClass('js-active');

			// De-activate all content tabs
			// $('.tab').removeClass('js-active');

			// Get and activate the associated spot
			const spotElement = mapSection.find('[data-title="' + spotTitle + '"]');
			spotElement.addClass('js-active');

			// Get and activate the associated tooltip (desktop only)
			if ($(window).width() >= 1000) {
				const spotId = spotElement.attr('data-object-id');
				const tooltipElement = $('[data-tooltip-id="' + spotId + '"]');
				tooltipElement.addClass('js-active');
			}

			// Hide all content items
			$('.child-item__content').removeClass('js-active');

			// Show the associated content item
			const childItemContent = $(this).next('.child-item__content');
			childItemContent.addClass('js-active');
		});



		// Clicked map nav child item close
		$('.map-nav .child-item__content .icon-close').click(function() {

			// De-activate all content tabs
			// $('.tab').removeClass('js-active');

			// Hide the whole child content item
			const childItemContent = $(this).closest('.child-item__content');
			childItemContent.removeClass('js-active');

			// Get the parent map section and the name of the Map Image
			const mapSection = $(this).closest('.section-map');
			const mapImageName = mapSection.find('[data-image-map-name]').data('image-map-name');

			// Re-center the map
			// ImageMapPro.reInitMap(mapImageName);

			// Get the value of the data-imp-trigger-object-on-mouseover attribute
			const spotTitle = $(this).closest('.child-item').find('.child-item__title').attr('data-imp-trigger-object-on-mouseover');

			// Get and de-activate the associated spot
			const spotElement = mapSection.find('[data-title="' + spotTitle + '"]');
			spotElement.removeClass('js-active');

			// Get and de-activate the associated tooltip (desktop only)
			if ($(window).width() >= 1000) {
				const spotId = spotElement.attr('data-object-id');
				const tooltipElement = $('[data-tooltip-id="' + spotId + '"]');
				tooltipElement.removeClass('js-active');
			}

			// console.log(mapImageName);
			// console.log(spotTitle);

			ImageMapPro.hideTooltip(mapImageName, spotTitle)

		});


		 // JavaScript Hooks
		ImageMapPro.subscribe((action) => {
			
			// When a spot is clicked, update the nav
			if (action.type === 'objectClick') {

				// De-activate all content tabs
				// $('.tab').removeClass('js-active');

				$('.section-map').find('.imp-object-spot').removeClass('js-active');
				$('.imp-tooltip').removeClass('js-active');
				$('.child-item__content').removeClass('js-active');

				$('.child-item__title[data-imp-trigger-object-on-mouseover="' + action.payload.object + '"]').click();

				// Scroll to the one that was clicked (mobile only)
				if ($(window).width() < 1000) {
					setTimeout(function() {
						$('html, body').animate({
							scrollTop: $('.child-item__title[data-imp-trigger-object-on-mouseover="' + action.payload.object + '"]').offset().top
						}, 1000);
					}, 1200); 
				}

			}


			// De-activate spots when artboard changes
			if (action.type === 'changeArtboard') {

				// De-activate all content tabs
				// $('.tab').removeClass('js-active');

				$('.section-map').find('.imp-object-spot').removeClass('js-active');
				$('.imp-tooltip').removeClass('js-active');

			}


			// Update tooltip position when map move (desktop only)
			if ($(window).width() >= 1000) {
				if (action.type === 'zoomPanUpdate') {

					var mapName = action.payload.map;
					var objectTitle =  $('.imp-object.js-active').data('title');

					// console.log(mapName + objectTitle);

					ImageMapPro.showTooltip(mapName, objectTitle)

				}
			}

		})


		// Nav accordion
		$('.parent-item').click(function() {

			// De-activate all content tabs
			// $('.tab').removeClass('js-active');

			$('.parent-item').removeClass('js-active');
			$(this).addClass('js-active');

		});


		//Tab menu
		$('.tabs-menu li').click(function() {

			var tabName = $(this).data('tab-name');

			// Update tab menu
			$(this).closest('.tabs-menu').attr('data-tab-active', tabName);
			// $(this).closest('.tabs-menu').addClass('tab-active');

			// Update visible tab for this child item
			$(this).closest('.child-item__content').find('.tab').removeClass('js-active');
			$(this).closest('.child-item__content').find('.tab[data-tab-name="' + tabName + '"]').addClass('js-active');


		});     



	}


});











// // Re-layout the map on window resize
// function debounce(func, wait) {
// 	let timeout;
// 	return function() {
// 		clearTimeout(timeout);
// 		timeout = setTimeout(func, wait);
// 	};
// }

// $(window).resize(debounce(function() {

// 	ImageMapPro.reInitMap("Map 1")
	
// }, 200));



// document.addEventListener('DOMContentLoaded', function() {

// 	// Clicked map nav child item title
// 	document.querySelectorAll('.map-nav .child-item__title').forEach(function(element) {
// 		element.addEventListener('click', function() {
// 			console.log('111');

// 			// Get the parent map section
// 			const mapSection = this.closest('.section-map');
	
// 			// Get the value of the data-imp-trigger-object-on-mouseover attribute
// 			const spotTitle = this.getAttribute('data-imp-trigger-object-on-mouseover');
			
// 			// Get and activate the associated spot
// 			const spotElement = mapSection.querySelector('[data-title="' + spotTitle + '"]');
// 			spotElement.classList.add('js-active');
	
// 			// Get and activate the associated tooltip
// 			const spotId = spotElement.getAttribute('data-object-id');
// 			const tooltipElement = document.querySelector('[data-tooltip-id="' + spotId + '"]');
// 			tooltipElement.classList.add('js-active');
	
// 			// Show the associated content item
// 			const childItemContent = this.nextElementSibling;
// 			childItemContent.classList.add('js-active');
// 		});
// 	});




// 	// Clicked map nav child item title
// 	document.querySelectorAll('.map-nav .child-item__content .close').forEach(function(element) {
// 		element.addEventListener('click', function() {
// 		// Hide the whole child content item
// 		const childItemContent = this.closest('.child-item__content');
// 		childItemContent.classList.remove('js-active');
// 		});
// 	});



// });



// ImageMapPro.changeArtboard('My Floor Plan', 'artboard-1')
// ImageMapPro.highlightObject('Map 1', 'Spot 1');
// ImageMapPro.showTooltip('Map 1', 'Spot 1');

// data-object-id="5a904a35-bb8c-4c7f-85ab-b7e2a96247b4"